/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Added_DescriptionInputs */

const en_compare_event_groups_added_description = /** @type {(inputs: Compare_Event_Groups_Added_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event exists in Group B but not in Group A`)
};

const fr_compare_event_groups_added_description = /** @type {(inputs: Compare_Event_Groups_Added_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'événement existe dans le groupe B mais pas dans le groupe A`)
};

const de_compare_event_groups_added_description = /** @type {(inputs: Compare_Event_Groups_Added_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Ereignis existiert in Gruppe B, aber nicht in Gruppe A.`)
};

const it_compare_event_groups_added_description = /** @type {(inputs: Compare_Event_Groups_Added_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'evento esiste nel Gruppo B ma non nel Gruppo A`)
};

const ru_compare_event_groups_added_description = /** @type {(inputs: Compare_Event_Groups_Added_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие существует в группе B, но отсутствует в группе A.`)
};

const es_compare_event_groups_added_description = /** @type {(inputs: Compare_Event_Groups_Added_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El evento existe en el Grupo B pero no en el Grupo A`)
};

const zh_cn2_compare_event_groups_added_description = /** @type {(inputs: Compare_Event_Groups_Added_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该事件存在于B组中，但不存在于A组中。`)
};

const ja_compare_event_groups_added_description = /** @type {(inputs: Compare_Event_Groups_Added_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントはグループ B には存在するがグループ A には存在しない`)
};

const hi_compare_event_groups_added_description = /** @type {(inputs: Compare_Event_Groups_Added_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह घटना समूह B में मौजूद है लेकिन समूह A में नहीं है।`)
};

const pt_pt2_compare_event_groups_added_description = /** @type {(inputs: Compare_Event_Groups_Added_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O evento existe no Grupo B, mas não no Grupo A.`)
};

/**
* | output |
* | --- |
* | "Event exists in Group B but not in Group A" |
*
* @param {Compare_Event_Groups_Added_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_added_description = /** @type {((inputs?: Compare_Event_Groups_Added_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Added_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_added_description(inputs)
	if (locale === "de") return de_compare_event_groups_added_description(inputs)
	if (locale === "it") return it_compare_event_groups_added_description(inputs)
	if (locale === "ru") return ru_compare_event_groups_added_description(inputs)
	if (locale === "es") return es_compare_event_groups_added_description(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_added_description(inputs)
	if (locale === "ja") return ja_compare_event_groups_added_description(inputs)
	if (locale === "hi") return hi_compare_event_groups_added_description(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_added_description(inputs)
	return en_compare_event_groups_added_description(inputs)
});